import {
  CREATE_API_APPLICATION,
  GET_API_APPLICATION,
  GET_API_APPLICATIONS,
  NAVIGATION,
  REGENERATE_API_APPLICATION_TOKEN,
  UPDATE_API_APPLICATIONS,
} from '../types';
import { error, success } from '../utils';

export let initialState = {
  getApiApplications: {
    isLoading: false,
    isError: false,
  },
  createApiApplication: {
    isLoading: false,
    isError: false,
  },
  getApiApplication: {
    isLoading: false,
    isError: false,
  },
  updateApiApplication: {
    isLoading: false,
    isError: false,
  },
  regenerateApiApplicationToken: {
    isLoading: false,
    isError: false,
  },
  applications: [],
  application: null,
  newApplication: {},
  regeneratedToken: '',
};

const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case CREATE_API_APPLICATION:
      return {
        ...state,
        createApiApplication: {
          isLoading: true,
          isError: false,
        },
      };
    case success(CREATE_API_APPLICATION):
      return {
        ...state,
        createApiApplication: {
          isLoading: false,
          isError: false,
        },
        newApplication: action.payload.data,
      };
    case error(CREATE_API_APPLICATION):
      return {
        ...state,
        createApiApplication: {
          isLoading: false,
          isError: true,
        },
      };

    case GET_API_APPLICATIONS:
      return {
        ...state,
        getApiApplications: {
          isLoading: true,
          isError: false,
        },
      };
    case success(GET_API_APPLICATIONS):
      return {
        ...state,
        getApiApplications: {
          isLoading: false,
          isError: false,
        },
        applications: action.payload.data,
      };
    case error(GET_API_APPLICATIONS):
      return {
        ...state,
        getApiApplications: {
          isLoading: false,
          isError: true,
        },
      };
    case GET_API_APPLICATION:
      return {
        ...state,
        getApiApplication: {
          isLoading: true,
          isError: false,
        },
      };
    case success(GET_API_APPLICATION):
      return {
        ...state,
        getApiApplication: {
          isLoading: false,
          isError: false,
        },
        application: action.payload.data,
      };
    case error(GET_API_APPLICATION):
      return {
        ...state,
        getApiApplication: {
          isLoading: false,
          isError: true,
        },
      };
    case UPDATE_API_APPLICATIONS:
      return {
        ...state,
        updateApiApplication: {
          isLoading: true,
          isError: false,
        },
      };
    case success(UPDATE_API_APPLICATIONS):
      return {
        ...state,
        updateApiApplication: {
          isLoading: false,
          isError: false,
        },
      };
    case error(UPDATE_API_APPLICATIONS):
      return {
        ...state,
        updateApiApplication: {
          isLoading: false,
          isError: true,
        },
      };
    case REGENERATE_API_APPLICATION_TOKEN:
      return {
        ...state,
        regenerateApiApplicationToken: {
          isLoading: true,
          isError: false,
        },
      };
    case success(REGENERATE_API_APPLICATION_TOKEN):
      return {
        ...state,
        regenerateApiApplicationToken: {
          isLoading: false,
          isError: false,
        },
        regeneratedToken: action.payload.data.apiToken,
      };
    case error(REGENERATE_API_APPLICATION_TOKEN):
      return {
        ...state,
        regenerateApiApplicationToken: {
          isLoading: false,
          isError: true,
        },
      };

    case NAVIGATION:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
